import React from "react";
import AppLayout from "@amzn/meridian/app-layout";
import LandingHeader from "src/components/pages/landing/header";
import LandingSideMenu from "src/components/pages/landing/sideMenu";
import LandingFooter from "src/components/pages/landing/footer";
import LandingHome from "src/components/pages/landing/home";

const LandingPage = () => {
  return (
    <AppLayout
      headerComponent={LandingHeader}
      sidebarComponent={LandingSideMenu}
      footerComponent={LandingFooter}
      spacingInset="500"
    >
      <LandingHeader />
      <LandingSideMenu />
      <LandingHome />
      <LandingFooter />
    </AppLayout>
  );
};

export default LandingPage;
